import { useMutation, useQueryClient } from 'react-query';
import { useModal } from 'store/modals';
import { useTenantId } from 'services/user/tenant/hook';
import { enableUserAPI } from './api';

const USERS = 'users';

export function useEnableUser({ onSuccess }) {
  const queryClient = useQueryClient();
  const { tenantId } = useTenantId();

  const { openModal } = useModal();

  const { mutate, isLoading, isError } = useMutation(
    (userId) => enableUserAPI(userId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([USERS, tenantId]);
        onSuccess();
      },

      onError: (error, user) => openModal({
        modalType: 'PopupModal',
        modalProps: {
          title: 'adminEnableUserModalTitleError',
          description: 'adminEnableUserModalDescriptionError',
          showActions: true,
          onRetry: () => mutate(user),
        },
      }),
    },
  );

  return {
    enableUser: mutate,
    isLoading,
    isError,
  };
}
